import React, { useState } from 'react';
import './AlphaNum.css';

const alphabets = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
const numbers = Array.from({ length: 10 }, (_, i) => i + 1);
const numbers10to20 = Array.from({ length: 11 }, (_, i) => i + 10);
const numbers20to30 = Array.from({ length: 11 }, (_, i) => i + 20);
const numbers30to40 = Array.from({ length: 11 }, (_, i) => i + 30);
const numbers40to50 = Array.from({ length: 11 }, (_, i) => i + 40);
const numbers50to60 = Array.from({ length: 11 }, (_, i) => i + 50);
const numbers60to70 = Array.from({ length: 11 }, (_, i) => i + 60);
const numbers70to80 = Array.from({ length: 11 }, (_, i) => i + 70);
const numbers80to90 = Array.from({ length: 11 }, (_, i) => i + 80);
const numbers90to100 = Array.from({ length: 11 }, (_, i) => i + 90);
const numbers100to150 = Array.from({ length: 51 }, (_, i) => i + 100);
const numbers150to200 = Array.from({ length: 51 }, (_, i) => i + 150);
const numbers10to1000 = Array.from({ length: 51 }, (_, i) => i * 10);
const numbers500to1000 = Array.from({ length: 11 }, (_, i) => i * 100);

const words = ['hello', 'world', 'react', 'javascript', 'coding', 'example', 'voice', 'select', 'option', 'button'];

 

const AlphaNum1 = () => {
  const [mode, setMode] = useState('alphabets');
  const [selectedItem, setSelectedItem] = useState(null);
  const[words, setWords]= useState('');

  const numberToWords = (num) =>{
    const zero=['Zero'];
    const ones = [ '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen' ];
     const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety']; 
    
     if (num < 20) return ones[num];
      if (num < 100) return tens[Math.floor(num / 10)] + (num % 10 !== 0 ? ' ' + ones[num % 10] : ''); 
      if (num < 1000) return ones[Math.floor(num / 100)] + ' Hundred ' + (num % 100 !== 0 ? numberToWords(num % 100) : '');
      if (num < 1000000) return numberToWords(Math.floor(num / 1000)) + ' Thousand ' + (num % 1000 !== 0 ? numberToWords(num % 1000) : ''); return num; };
     



  const speak = (text) => {
    const msg = new SpeechSynthesisUtterance(text);
    window.speechSynthesis.speak(msg);
  };

  const handleClick = (item) => {
    speak(item);
    setSelectedItem(item);
    setWords(numberToWords(parseInt(item, 10)));
  };

  const getImageSrc = (item) => {
    // Placeholder logic to generate image URL based on the item
    return `https://via.placeholder.com/150?text=${item}`;
  };

  return (
    <div className="AppAN">
      <h1>Select to Display Numbers</h1>
      <div className="select-container">
        <select onChange={(e) => setMode(e.target.value)} className="select">
          {/* <option value="alphabets">Alphabets</option> */}
          <option value='select'>Select Numbers</option>
          <option value="numbers">Numbers from 1 to 10</option>
          <option value="numbers10to20">Numbers from 10 to 20</option>
          <option value="numbers20to30">Numbers from 20 to 30</option>
          <option value="numbers30to40">Numbers from 30 to 40</option>
          <option value="numbers40to50">Numbers from 40 to 50</option>
          <option value="numbers50to60">Numbers from 50 to 60</option>
          <option value="numbers60to70">Numbers from 60 to 70</option>
          <option value="numbers70to80">Numbers from 70 to 80</option>
          <option value="numbers80to90">Numbers from 80 to 90</option>
          <option value="numbers90to100">Numbers from 90 to 100</option>
          <option value="numbers100to150">Numbers from 100 to 150</option>
          <option value="numbers150to200">Numbers from 150 to 200</option>
          <option value="numbers10to1000">Numbers from 0 to 500 in Tens</option>
          <option value="numbers500to1000">Numbers from 0 to 1000 in hundreds</option>
          {/* <option value="words">Words</option> */}
        </select>
      </div>
      <div className="container">
        {/* {mode === 'alphabets' && (
          <div className="alphabets">
            {alphabets.map((letter) => (
              <button key={letter} onClick={() => handleClick(letter)} className="button">
                {letter}
              </button>
            ))}
          </div>
        )} */}
        {mode === 'numbers' && (
          <div className="numbers">
            {numbers.map((number) => (
              <button key={number} onClick={() => handleClick(number)} className="button">
                {number}
              </button>
            ))}
          </div>
        )}
        {mode === 'numbers10to20' && (
          <div className="numbers">
            {numbers10to20.map((number) => (
              <button key={number} onClick={() => handleClick(number)} className="button">
                {number}
              </button>
            ))}
          </div>
        )}
           {mode === 'numbers20to30' && (
          <div className="numbers">
            {numbers20to30.map((number) => (
              <button key={number} onClick={() => handleClick(number)} className="button">
                {number}
              </button>
            ))}
          </div>
        )}
         {mode === 'numbers30to40' && (
          <div className="numbers">
            {numbers30to40.map((number) => (
              <button key={number} onClick={() => handleClick(number)} className="button">
                {number}
              </button>
            ))}
          </div>
        )}
         {mode === 'numbers40to50' && (
          <div className="numbers">
            {numbers40to50.map((number) => (
              <button key={number} onClick={() => handleClick(number)} className="button">
                {number}
              </button>
            ))}
          </div>
        )}
         {mode === 'numbers50to60' && (
          <div className="numbers">
            {numbers50to60.map((number) => (
              <button key={number} onClick={() => handleClick(number)} className="button">
                {number}
              </button>
            ))}
          </div>
        )}
         {mode === 'numbers60to70' && (
          <div className="numbers">
            {numbers60to70.map((number) => (
              <button key={number} onClick={() => handleClick(number)} className="button">
                {number}
              </button>
            ))}
          </div>
        )}
         {mode === 'numbers70to80' && (
          <div className="numbers">
            {numbers70to80.map((number) => (
              <button key={number} onClick={() => handleClick(number)} className="button">
                {number}
              </button>
            ))}
          </div>
        )}
         {mode === 'numbers80to90' && (
          <div className="numbers">
            {numbers80to90.map((number) => (
              <button key={number} onClick={() => handleClick(number)} className="button">
                {number}
              </button>
            ))}
          </div>
        )}
         {mode === 'numbers90to100' && (
          <div className="numbers">
            {numbers90to100.map((number) => (
              <button key={number} onClick={() => handleClick(number)} className="button">
                {number}
              </button>
            ))}
          </div>
        )}
         {mode === 'numbers100to150' && (
          <div className="numbers">
            {numbers100to150.map((number) => (
              <button key={number} onClick={() => handleClick(number)} className="button">
                {number}
              </button>
            ))}
          </div>
        )}
         {mode === 'numbers150to200' && (
          <div className="numbers">
            {numbers150to200.map((number) => (
              <button key={number} onClick={() => handleClick(number)} className="button">
                {number}
              </button>
            ))}
          </div>
        )}
            {mode === 'numbers10to1000' && (
          <div className="numbers">
            {numbers10to1000.map((number) => (
              <button key={number} onClick={() => handleClick(number)} className="button">
                {number}
              </button>
            ))}
          </div>
        )}

               {mode === 'numbers500to1000' && (
          <div className="numbers">
            {numbers500to1000.map((number) => (
              <button key={number} onClick={() => handleClick(number)} className="button">
                {number}
              </button>
            ))}
          </div>
        )}
        {/* {mode === 'words' && (
          <div className="words">
            {words.map((word) => (
              <button key={word} onClick={() => handleClick(word)} className="button">
                {word}
              </button>
            ))}
          </div>
        )} */}
        {selectedItem && (
          <div className="three-d">
            {/* <img src={getImageSrc(selectedItem)} alt={selectedItem} /> */}
            {selectedItem}<br/>
            {words}
          </div>
        )}
      </div>
    </div>
  );
};

export default AlphaNum1;
